export default __webpack_public_path__ + "static/media/WStore_Quests.084f8769.png";